<app-alert-modal
  #loyaltyOnlyModal
  [showCrossBtn]="false"
  [closeModalOnEsc]="false"
  [confirmBtnLabel]="TEXT.PROCEED"
  [cancelBtnLabel]="TEXT.BACK"
  [confirmButtonClass]="'btn btn-default'"
  [cancelButtonClass]="'btn btn-primary'"
  [dynamicClass]="'loyalty-only-warning-modal'"
  [modalOptions]="{ class: 'modal-dialog-centered' }"
  (confirmed)="handleProceed()"
  (canceled)="handleCancel()"
>
  <div class="loyalty-only-warning-modal-content">
    <em class="icon-liteAlert"></em>
    <div class="loyalty-only-warning-modal-copy">
      <p>{{ TEXT.MESSAGE_PARAGRAPH_1 }}</p>
      <p>{{ TEXT.MESSAGE_PARAGRAPH_2 }}</p>
    </div>
  </div>
</app-alert-modal>
